// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/components/CardAdvisor/style.scss
// module id = 741
// module chunks = 0